import { createSlice } from "@reduxjs/toolkit";
import { matchDetailInitialState } from "../initialState";

const matchDetailSlice = createSlice({
  name: "matchDetail",
  initialState: matchDetailInitialState,
  reducers: {
    // Match Info
    fetchMatchInfoStart: function(state) {
      state.loading.matchInfo = true;
      state.errors.matchInfo = null;
    },
    fetchMatchInfoSuccess: function(state, action) {
      state.matchInfo = action.payload.matchInfo;
      state.scoreUrl = action.payload.scoreUrl;
      state.tvUrl = action.payload.tvUrl;
      state.channelId = action.payload.channelId;
      state.loading.matchInfo = false;
    },
    fetchMatchInfoFail: function(state, action) {
      state.loading.matchInfo = false;
      state.errors.matchInfo = action.payload;
    },

    // Odds/Bookmaker Data
    fetchOddsStart: function(state) {
      state.loading.odds = true;
      state.errors.odds = null;
    },
    fetchOddsSuccess: function(state, action) {
      state.bookmakerData = action.payload.bookmaker;
      state.fancyData = action.payload.fancy;
      state.loading.odds = false;
    },
    fetchOddsFail: function(state, action) {
      state.loading.odds = false;
      state.errors.odds = action.payload;
    },

    // Fancy List
    fetchFancyListStart: function(state) {
      state.loading.fancy = true;
      state.errors.fancy = null;
    },
    fetchFancyListSuccess: function(state, action) {
      state.fancyList = action.payload;
      state.loading.fancy = false;
    },
    fetchFancyListFail: function(state, action) {
      state.loading.fancy = false;
      state.errors.fancy = action.payload;
    },

    // Match Bets
    fetchMatchBetsStart: function(state) {
      state.loading.bets = true;
      state.errors.bets = null;
    },
    fetchMatchBetsSuccess: function(state, action) {
      state.matchBets = action.payload;
      state.loading.bets = false;
    },
    fetchMatchBetsFail: function(state, action) {
      state.loading.bets = false;
      state.errors.bets = action.payload;
    },

    // Session Bets
    fetchSessionBetsSuccess: function(state, action) {
      state.sessionBets = action.payload;
    },

    // Completed Fancy
    fetchCompletedFancyStart: function(state) {
      state.loading.completedFancy = true;
      state.errors.completedFancy = null;
    },
    fetchCompletedFancySuccess: function(state, action) {
      state.completedFancy = action.payload;
      state.loading.completedFancy = false;
    },
    fetchCompletedFancyFail: function(state, action) {
      state.loading.completedFancy = false;
      state.errors.completedFancy = action.payload;
    },

    // Reset
    resetMatchDetail: function(state) {
      return matchDetailInitialState;
    },
  },
});

export default matchDetailSlice.reducer;
export const matchDetailActions = matchDetailSlice.actions;